<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
        
        <a-config-provider>
          <template v-slot:renderEmpty>
            <a-empty>
              <span slot="description">还没有数据~</span>
            </a-empty>
          </template>
          <div class="config-provider">
            <a-button  type="primary"  :style="{ margin: '5px' }"  class="ui-search-action" @click="chooseTest">选择考试</a-button>
            <a-table
              :columns="list.columns"
              rowKey="id"
              :pagination="false"
              :dataSource="list.datas"
              :loading="isloading"
              size="small"
            >
              <span slot="status" slot-scope="status">
                <a-tag v-if="status" color="green">是</a-tag>
                <a-tag v-else color="red">否</a-tag>
              </span>
              <span slot="trigger" slot-scope="trigger">
                  <template v-if="trigger.type==0">学分({{trigger.value}})</template>
                  <template v-if="trigger.type==1">学时({{trigger.value}})</template>
                  <template v-if="trigger.type==2">关联课程</template>
                  <template v-if="trigger.type==3">关联考试</template>
              </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn name="编辑" size="small" @click="showTestinfo(info.id)" type="primary" />
                <a-divider type="vertical" />
                <pxkeji-btn name="条件设置" size="small" @click="setTrigger(info.id)" type="primary" />
                <a-divider type="vertical" />
                <pxkeji-btn name="移除" size="small" @click="delInfo(info.id)" type="default" />
              </span>
            </a-table>
          </div>
        </a-config-provider>

      <a-modal
        v-model="chooseTestShow"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <testChoose @callbackMethod="addTest" :ids="list.ids"/>
      </a-modal>

      <a-modal
        v-model="editTestShow"
        :footer="false"
        destroyOnClose
        title="考试信息"
        width="40%"
        :maskClosable="false"
        class="ui-modal"
      >
        <testInfo @callbackMethod="closeTestinfo" :infos="{id:list.editId}" />
      </a-modal>

      <a-modal
        v-model="triggerModal.triggerShow"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <trigger @callbackMethod="closeTrigger" :projectId="projectId" :id="triggerModal.id" :dataType="1"/>
      </a-modal>

    </div>
    
  </a-spin>
</template>

<script>
import testChoose from "./testChoose.vue";
import trigger from "./trigger.vue";
import testInfo from "../examination/examinationInfo.vue";

const columns = [
  {
    dataIndex: "testName",
    key: "testName",
    align: "center",
    title: "考试名称"
  },
  {
    dataIndex: "questionsCount",
    key: "questionsCount",
    align: "center",
    title: "题目数量"
  },
  {
    dataIndex: "passLine",
    key: "passLine",
    align: "center",
    title: "及格分数线"
  },
  
  {
    dataIndex: "examPeople",
    key: "examPeople",
    align: "center",
    title: "考试人数"
  },
  {
    dataIndex: "trigger",
    key: "trigger",
    align: "center",
    title: "考试条件",
    scopedSlots: { customRender: "trigger" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

var that;

export default {
  name: "trainRecord",
  props: {
    projectId:String
  },
  watch:{
    id: {
      immediate:true, 
      handler(newVal,oldVal) {
         if(newVal){
          this.projectId=newVal;
          this.GetList();
        }
      }
    } 
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        editId:0,
        ids:[],
        trigger:{}
      },
      form: this.$form.createForm(this),
      triggerModal:{
        triggerShow: false,
        id:0
      },
      
      isloading: false,
      loadingTip: "加载中...",
      chooseTestShow: false, //选择考试
      editTestShow: false, //编辑考试
    };
  },
  components: {
    testChoose: testChoose,
    testInfo: testInfo,
    trigger
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      if(this.projectId){
        this.GetList();
      }
      
    });
  },
  methods: {
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    setTrigger(id){
      this.triggerModal.triggerShow=true;
      this.triggerModal.id=id;
    },
    closeTrigger(flag){
      this.triggerModal.triggerShow=false;
      if(flag){
        this.GetList();
      }
    },
    GetList() {
      if(this.projectId>0){
        this.isloading = true;
        this.clearRows();
        this.$api.project
          .getExaminationForProject(
            this.projectId
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.list.datas = res.data.examinations;
              this.list.trigger=res.data.trigger;
                this.list.ids=[];
                if(this.list.datas){
                  this.list.datas.forEach(function(item,index){
                    that.list.ids.push(item.id);
                    if(that.list.trigger){
                        for(var t in that.list.trigger){
                          if(that.list.trigger[t].dataId==item.id){
                            item.trigger=that.list.trigger[t];
                          }
                        }
                    }
                  })
                }
              
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      }
    },
    
    chooseTest() {
      this.chooseTestShow = true;
    },
    addTest(ids) {
      this.chooseTestShow = false;
      this.isloading = true;
        this.clearRows();
        this.$api.project
          .addExaminationToProject(
            this.projectId,ids
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              that.GetList();
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    showTestinfo(id) {
      this.editTestShow = true;
      this.list.editId=id;
    },
    closeTestinfo(id) {
      this.editTestShow = false;
      if(id){
        //新增，需要增加关联关系
        this.isloading = true;
        this.clearRows();
        this.$api.project
          .addExaminationToProject(
            this.projectId,id
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              that.GetList();
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      }

    },
    delInfo(id){
       this.$confirm({
          title: "提示",
          content: "您确定要移除考试吗",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            that.isloading = true;
            that.clearRows();
            that.$api.project
              .removeExaminationFromProject(
                that.projectId,id
              )
              .then(res => {
                that.isloading = false;
                if (res.errorCode == that.$msg.responseCode.success) {
                  that.GetList();
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                that.isloading = false;
              });
          },
          onCancel() {}
        });
        
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
    
  }
};
</script>
<style>
</style>